
import { computed, defineComponent, ref, watch, toRef, onMounted,PropType } from "vue";
import ColorSketch from "../color-sketch/color-sketch.vue";
import { GradientColor, ColorType } from "@qcolor/utils/gradientTools/gradientModel";
import { gradientString } from "@qcolor/utils/gradientTools/gradientTools";
import { ElPopover } from "element-plus";
//import "element-plus/es/components/popover/style/css";
import { uniq, some, cloneDeep } from "lodash-es";
export default defineComponent({
  name: "ColorPicker",
  inheritAttrs: false,
  components: {
    ElPopover,
    ColorSketch,
  },
  emits: ["update:selectType", "update:color","show","hide","before-enter","after-enter","before-leave","after-leave"],
  props: {
    color: {
      type: [String, Object],
      default: "#ffffff",
    },
    selectType: {
      type: Number,
      default: -1, //gradientColor  color ColorType.Color
    },
    popoverWidth: {
      type: Number,
      default: 278,
    },
    placement: {
      type: String,
      default: "bottom",
    },
    trigger: {
      type: String,
      default: "click",
    },
    teleported:{
      type:Boolean,
      default:true,
    },
    pictureUrl:{
      type: String,
      default: "",      
    },
    styleInfo: {
      type: Object as PropType<any>,
      default: () => ({}),
    },
  },
  setup(props) {
    const colorSonRef: any = ref(null);
    const recentColorList: any = ref([]);
    const recentGradientList: any = ref([]);
    const sketchShow = ref(false);

    const myColors: any = ref("#ffffff");
    const myGradientColors: any = ref(new GradientColor());

    const activeTab = ref(props.selectType);

    if(activeTab.value === -1){
      if(typeof props.color === 'string'){
        activeTab.value = ColorType.Color;
      }else if(typeof props.color === 'object'){
        activeTab.value = ColorType.GradientColor;
      }
    }

    if (activeTab.value === ColorType.Color) {
      myColors.value = cloneDeep(props.color);
    } else if (activeTab.value === ColorType.GradientColor) {
      myGradientColors.value = cloneDeep(props.color);
    }

    const handleWindowKey = (e: any) => {
      if (e.keyCode === 46) {
        colorSonRef.value.deletOneGradientItem();
        e.stopPropagation();
        e.preventDefault();
      }
    };

    const popoverShow2 = () => {
      window.addEventListener("keydown", handleWindowKey);
      const v = sessionStorage.getItem("recentColorList");
      const g = sessionStorage.getItem("recentGradientList");
      if (v) {
        try {
          recentColorList.value = JSON.parse(v);
        } catch (error) {
          console.log(error);
        }
      }
      if (g) {
        try {
          recentGradientList.value = JSON.parse(g);
        } catch (error) {
          console.log(error);
        }
      }
    };
    const popoverHide2 = () => {
      window.removeEventListener("keydown", handleWindowKey);

      if (activeTab.value === ColorType.Color) {
        recentColorList.value.unshift(myColors.value);
        // 判断当前颜色列表是否有相同值，如果有，去重
        recentColorList.value = uniq(recentColorList.value);
        if (recentColorList.value.length >= 12) {
          recentColorList.value = recentColorList.value.slice(0, 12);
        }
        sessionStorage.setItem(
          "recentColorList",
          JSON.stringify(recentColorList.value)
        );
      } else if (activeTab.value === ColorType.GradientColor) {
        // 判断当前颜色列表是否有相同值，如果有，不更新数组
        if (
          !some(recentGradientList.value, {
            gradient: gradientString(myGradientColors.value as any)
              .replace("linear-gradient(", "")
              .replace(")", ""),
          })
        ) {
          recentGradientList.value.unshift({
            gradient: gradientString(myGradientColors.value as any)
              .replace("linear-gradient(", "")
              .replace(")", ""),
          });
        }

        if (recentGradientList.value.length >= 12) {
          recentGradientList.value = recentGradientList.value.slice(0, 12);
        }
        sessionStorage.setItem(
          "recentGradientList",
          JSON.stringify(recentGradientList.value)
        );
      }
    };

    const upColor = (item: any) => {
      if (activeTab.value === ColorType.Color) {
        myColors.value = item;
      } else if (activeTab.value === ColorType.GradientColor) {
        myGradientColors.value = item;
      }
    };

    const gradientColorStr = computed(() => {
      if (activeTab.value === ColorType.GradientColor) {
        return  gradientString(myGradientColors.value as any);
      } else {
        return new GradientColor();
      }
    });

    watch(
      () => props.selectType,
      (newV) => {
        activeTab.value = newV;
      }
    );
    watch(
      () => props.color,
      (newV) => {
      if(!newV) return;
      let activeTabClone:any = undefined;

      if (typeof newV === "string") {
        activeTabClone = ColorType.Color;
      } else if (typeof newV === "object") {
        activeTabClone = ColorType.GradientColor;
      }  
      
      if(activeTabClone !== undefined && activeTabClone !== activeTab.value){
        activeTab.value = activeTabClone;
      }  


        if (activeTab.value === ColorType.Color) {
          myColors.value = cloneDeep(newV);
        } else if (activeTab.value === ColorType.GradientColor) {
          myGradientColors.value = cloneDeep(newV);
        }
      }
    );



    return {
      gradientColorStr,
      ColorType,
      colorSonRef,
      recentColorList,
      recentGradientList,
      activeTab,
      myColors,
      upColor,
      sketchShow
    };
  },
});
